import React, { createRef, Fragment, useEffect, useState } from 'react';
import { shape, string, func, arrayOf, bool } from 'prop-types';

const Characteristics = ( props ) => {

    const { metadata, emit, disabled, clearChart } = props;

    const [ activeGroup, setActiveGroup ] = useState( '' );
    const [ activeCharacteristics, setActiveCharacteristics ] = useState( [] );
    const [ isMobile, setIsMobile ] = useState( window.innerWidth < 1236 );

    const handleWindowResize = () => {

        setIsMobile( window.innerWidth < 1236 );

    };

    const onInputChange = ( inputRef, groupRef ) => {

        const dataProp = inputRef.current.id;

        if ( activeCharacteristics.length < 2 && inputRef.current.checked ) {

            setActiveCharacteristics( ( prev ) => [ ...prev, dataProp ] );

        }

        if ( !inputRef.current.checked && activeCharacteristics.includes( dataProp ) ) {

            const curState = activeCharacteristics.slice();

            curState.splice( curState.indexOf( dataProp ), 1 );
            setActiveCharacteristics( curState );

        }

        clearChart();

    };

    const renderSubFilters = () => {

        const found = metadata.find( ( e ) => e.prefix === activeGroup );

        if ( !found ) return;

        return found.facets.map( ( facet, idx ) => {

            const inputRef = createRef();

            const id = facet.property;

            return (
                <Fragment key={ `${ facet.property }-${ idx }` }>
                    <div className={ [
                        ( activeCharacteristics.length >= 2 && !activeCharacteristics.includes( id ) )
                        ? 'ude-characteristics-filtersets-detail-filter disabled'
                        : 'ude-characteristics-filtersets-detail-filter',
                        facet.property.includes( 'avg' ) ? 'avg-filter' : '',
                        facet.property.includes( 'card' ) ? 'credit-overflow' : ''
                    ].join( ' ' ) }
                    >
                        <input
                            id={ id }
                            type='checkbox'
                            ref={ inputRef }
                            checked={ activeCharacteristics.includes( id ) }
                            onChange={ () => onInputChange( inputRef ) }
                        />

                        <label htmlFor={ id }>
                            { isMobile ? facet.description.mobile : facet.description.desktop }
                        </label>
                    </div>
                </Fragment>
            );

        } );

    };

    window.addEventListener( 'resize', handleWindowResize );

    useEffect( () => {

        if ( disabled ) {

            if ( activeCharacteristics.length > 0 ) {

                setActiveCharacteristics( [] );

            }

            emit( [] );

        }

        emit( activeCharacteristics );

    }, [ activeCharacteristics ] );

    const clearAllDebtCharacteristics = () => {

        setActiveCharacteristics( [] );
        clearChart();

    };

    return (
        <div className={ [ disabled ? 'ude-disabled' : '', 'ude-characteristics' ].join( ' ' ) }>
            <div className='ude-characteristics-header'>
                <h2>Debt Characteristics</h2>
                <span>(select up to 2)</span>
            </div>

            {
                activeCharacteristics.length > 0 &&
                <a onClick={ clearAllDebtCharacteristics } className='ude-characteristics-clearall'>Clear All Debt Characteristics</a>
            }

            <div className='ude-characteristics-filtersets'>
                { metadata.map( ( field ) => {

                    const key = `${ field.name.replace( /\s/g, '' ) }-id`;
                    const p = field['prefix'];

                    return (
                        <div
                            data-group={ p }
                            className={ [
                                activeGroup === p ? isMobile ? 'mobile-active' : 'active' : '',
                                activeCharacteristics.length >= 2 && !activeCharacteristics.some( ( facet ) => facet.split( '_' )[0] === p ) ? 'disabled' : '',
                                activeCharacteristics.some( ( facet ) => facet.split( '_' )[0] === p ) ? 'contains-active-characteristic' : ''
                            ].join( ' ' ) }
                            onClick={ ( ) => {

 setActiveGroup( p );

} }
                            key={ key }
                        >
                            <h3>{ field.name }</h3>

                            { activeGroup === p
                                ? <div className='ude-characteristics-filtersets-detail'>
                                    { isMobile && renderSubFilters() }
                                </div>
                                : null
                            }
                        </div>
                    );

                } ) }
            </div>

            { ( !isMobile && activeGroup.length > 0 ) &&
                <div className='ude-characteristics-filterdetails'>
                    { renderSubFilters() }
                </div>
            }
        </div>
    );

};

Characteristics.propTypes = {
    metadata: arrayOf( shape ( {
        name: string.isRequired,
        prefix: string.isRequired,
        facets: arrayOf( shape( {
            property: string.isRequired,
            description: shape( {
                mobile: string.isRequired,
                desktop: string.isRequired
            } ).isRequired
        } ) ).isRequired
    } ) ).isRequired,
    emit: func.isRequired,
    disabled: bool.isRequired,
    clearChart: func.isRequired
};

export default Characteristics;